function phone_number(number: string | null | undefined) {
    number = (number || '').replace(/[\s().-]/g, '');

    // Strip spaces
    number = number.replace(/ /g,'');

    // Strip Parenthesis ()
    number = number.replace(/[{()}]/g,'');

    // Remove +
    number = number.replace(/\+/g,'');

    // Replace 61
    if (number.substring(0,2) == "61") {
        number = "0" + number.substring(2);
    }

    // if its only a 8 digit number add an 03 on it
    if (number.length == 8) {
        number = "03" + number;
    }

    return number;
}

function validate_phone_number(number: string | null | undefined) {

    if (number == undefined || number == null || number == '') {
        return false;
    }

    number = phone_number(number);

    // https://stackoverflow.com/questions/39990179/regex-for-australian-phone-number-validation
    //let phonePattern = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/
    //let phonePattern = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/;
    let phonePattern = /^(?=.*)((?:\+61) ?(?:\((?=.*\)))?([2-47-8])\)?|(?:\((?=.*\)))?([0-1][2-47-8])\)?) ?-?(?=.*)((\d{1} ?-?\d{3}$)|(00 ?-?\d{4} ?-?\d{4}$)|( ?-?\d{4} ?-?\d{4}$)|(\d{2} ?-?\d{3} ?-?\d{3}$))/;

    if (number.match(phonePattern)) {
        return true;
    } else {
        return false;
    }

}

function is_phone_number_a_mobile(number: string | null | undefined) {
    number = phone_number(number);
    // First validate if its even a phone number
    if (!validate_phone_number(number)) {
        return false;
    }

    // Does it have a leading 04?
    if (number.substring(0, 2) == "04") {
        return true;
    } else {
        return false;
    }
}

function human_phone (phone: string | null | undefined) {

    phone = phone_number(phone);

    if (!validate_phone_number(phone)) return phone;

    // 046604070

    // For mobiles
    if (is_phone_number_a_mobile(phone)) {
        phone = phone.substring(0, 4) + " " + phone.substring(4, 7) + " " + phone.substring(7, 10);
    } else if (phone.length == 10 && phone.substring(0,1) == '0') {
        // Landline: (03) 5442 5544
        phone = "(" + phone.substring(0, 2) + ") " + phone.substring(2, 6) + " " + phone.substring(6, 10);
    }

    // 131313
    if (phone.length == 6 && phone.substring(0,2) == '13') {
        phone = phone.substring(0, 2) + " " + phone.substring(2, 4) + " " + phone.substring(4, 6);
    }

    // 1800132468
    if (phone.length == 10 && phone.substring(0,1) == '1') {
        phone = phone.substring(0, 4) + " " + phone.substring(4, 7) + " " + phone.substring(7, 10);
    }


    return phone;

}

export { phone_number, validate_phone_number, is_phone_number_a_mobile, human_phone }
